import * as types from '../action-types';
import Client from '../../services/api';

export const getBookings = (startTime, endTime, places) => async (dispatch) => {
  try {
    dispatch({ type: types.GET_BOOK_DATA });
    const { bookings: fetchBookings } = await Client.get('api/v1/booking/current', {
      startTime: encodeURIComponent(startTime),
      endTime: encodeURIComponent(endTime),
      places,
    });

    const bookings = await Promise.all(
      fetchBookings.map(async (book) => {
        const { user } = await Client.get(`api/v1/users/${book.user}`, {});
        return { ...book, user };
      }),
    );

    dispatch({ type: types.GET_BOOK_DATA_SUCCESS, payload: bookings });
  } catch (e) {
    dispatch({ type: types.GET_BOOK_DATA_SUCCESS, payload: [] });
    dispatch({ type: types.GET_BOOK_DATA_FAILURE, payload: e.data.message });
    console.log('getBookings error', e);
  }
};

export const getPlaceInfo = (placeId) => async (dispatch) => {
  try {
    dispatch({ type: types.GET_PLACE_INFO });
    let zoneInfo = {},
      zoneFilters = [];
    const { place: fetchPlaceInfo } = await Client.get('api/v1/places/' + placeId, {});
    if (fetchPlaceInfo.zone) {
      zoneInfo = await Client.get(`api/v1/zones/${fetchPlaceInfo.zone}`, {});
      zoneFilters = await Client.get(`api/v1/zones/${fetchPlaceInfo.zone}/filters`, {});
    }

    const payload = { place_info: fetchPlaceInfo, zone_info: zoneInfo, zone_filters: zoneFilters };

    dispatch({ type: types.GET_PLACE_INFO_SUCCESS, payload: payload });
  } catch (e) {
    dispatch({ type: types.GET_PLACE_INFO_FAILURE, payload: e });
    console.log('getPlaceInfo error', e);
  }
};

export const checkIn = (bookId) => async (dispatch) => {
  try {
    const response = await Client.put(`api/v1/admin/bookings/${bookId}/checkin` + bookId, {});
    console.log('checkIn response', response);
  } catch (e) {
    console.log('checkIn error', e);
  }
};
